const DepartmentEndpoints = {
    department(reqData: any) {
    return {
      url: "sow/department",
      data: reqData["reqBody"],
      headers: reqData["headers"],
    };
  }
};
export default DepartmentEndpoints;